import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import React, { useEffect } from 'react'
import CommonFormHeading from '../../CommonUtils/CommonFormHeading'
import * as bie from "react-bootstrap";
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import { config } from '../../CommonUtils/CommonURLS';
import Swal from 'sweetalert2';
import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts';
import { AC_YEAR_OLD, ERROR_MSG } from '../../CommonUtils/contextVariables';
import * as Yup from 'yup';
import allowNumbersOnly, { handlePaste } from '../../CommonUtils/CommonValidations';
import { viewImage } from '../../CommonUtils/viewImage';
import { ImagePdfBucket } from '../../CommonUtils/ImagesBase64';
import { GetCollegeType } from '../../Reducers/AffiliationCommonservice';
import { useSelector } from 'react-redux';
import { FaEye } from 'react-icons/fa';
export default function FfcaQuestionarrie6() {
    const Collegetype = useSelector((state) => state?.commonMastersReducer?.CollegeType);
    const AffQuestion6validation = Yup.object({
        ugAddmitted: Yup.string().required(ERROR_MSG).nullable(),
        pgAddmitted: Yup.string().required(ERROR_MSG).nullable(),
        ugAttendance: Yup.string().required(ERROR_MSG).nullable(),
        pgAttendance: Yup.string().required(ERROR_MSG).nullable(),
        ugReadmitted: Yup.string().required(ERROR_MSG).nullable(),
        pgReadmitted: Yup.string().required(ERROR_MSG).nullable(),
        ugPlacements: Yup.string().required(ERROR_MSG).nullable(),
        pgPlacements: Yup.string().required(ERROR_MSG).nullable(),
        ugGate2022: Yup.string().required(ERROR_MSG).nullable(),
        pgGate2022: Yup.string().required(ERROR_MSG).nullable(),
        ugCat2022: Yup.string().required(ERROR_MSG).nullable(),
        pgCat2022: Yup.string().required(ERROR_MSG).nullable(),
        ugWorkshops: Yup.string().required(ERROR_MSG).nullable(),
        pgWorkshops: Yup.string().required(ERROR_MSG).nullable(),
        ugPublish: Yup.string().required(ERROR_MSG).nullable(),
        pgPublish: Yup.string().required(ERROR_MSG).nullable(),
        ugIntlWorkshop: Yup.string().required(ERROR_MSG).nullable(),
        pgIntlWorkshop: Yup.string().required(ERROR_MSG).nullable(),
        ugSports: Yup.string().required(ERROR_MSG).nullable(),
        pgSports: Yup.string().required(ERROR_MSG).nullable(),
        ugNccNss: Yup.string().required(ERROR_MSG).nullable(),
        pgNccNss: Yup.string().required(ERROR_MSG).nullable(),
        ugMalpractice: Yup.string().required(ERROR_MSG).nullable(),
        pgMalpractice: Yup.string().required(ERROR_MSG).nullable(),
        supportingDoc: Yup.string().required(ERROR_MSG).nullable(),
    });
    const AffiliationQuestions6Formik = useFormik({
        initialValues: {
            ugAddmitted: "",
            pgAddmitted: "",
            ugAttendance: "",
            pgAttendance: "",
            ugReadmitted: "",
            pgReadmitted: "",
            ugPlacements: "",
            pgPlacements: "",
            ugGate2022: "",
            pgGate2022: "",
            ugCat2022: "",
            pgCat2022: "",
            ugWorkshops: "",
            pgWorkshops: "",
            ugPublish: "",
            pgPublish: "",
            ugIntlWorkshop: "",
            pgIntlWorkshop: "",
            ugSports: "",
            pgSports: "",
            ugNccNss: "",
            pgNccNss: "",
            ugMalpractice: "",
            pgMalpractice: "",
            supportingDoc: "",
        },
        validationSchema: AffQuestion6validation,
        onSubmit: (values) => {
            const payload = Object.fromEntries(
                Object.entries(values).map(([key, value]) => {

                    if (key === 'supportingDoc') {
                        return [key, value];
                    }
                    return [key, parseInt(value, 10) || 0];
                })
            );
            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = `${config.url.API_URL}saveAffiliationQuestions6details`;
                    CommonAxiosPost(url, payload).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlert2(res?.data?.sdesc);
                            GetQuestionsubmited6();
                        } else {
                            failureAlert(res?.data?.sdesc);
                        }
                    });
                } else {
                    console.log('Submission canceled');
                }
            });
        },


    })
    function GetQuestionsubmited6() {
        let url = config?.url?.API_URL + "getAffiliationQuestions6Details";
        CommonAxiosGet(url).then((res) => {

            if (res?.data?.status === true && res?.data?.scode === "01") {
                res?.data?.getAffiliationQuestions6Details?.forEach((data, i) => {
                    AffiliationQuestions6Formik?.setFieldValue(`ugAddmitted`, data?.ug_addmitted);
                    AffiliationQuestions6Formik?.setFieldValue(`pgAddmitted`, data?.pg_addmitted);
                    AffiliationQuestions6Formik?.setFieldValue(`ugAttendance`, data?.ug_attendance);
                    AffiliationQuestions6Formik?.setFieldValue(`pgAttendance`, data?.pg_attendance);
                    AffiliationQuestions6Formik?.setFieldValue(`ugReadmitted`, data?.ug_readmitted);
                    AffiliationQuestions6Formik?.setFieldValue(`pgReadmitted`, data?.pg_readmitted);
                    AffiliationQuestions6Formik?.setFieldValue(`ugPlacements`, data?.ug_placements);
                    AffiliationQuestions6Formik?.setFieldValue(`pgPlacements`, data?.pg_placements);
                    AffiliationQuestions6Formik?.setFieldValue(`ugGate2022`, data?.ug_gate2022);
                    AffiliationQuestions6Formik?.setFieldValue(`pgGate2022`, data?.pg_gate2022);
                    AffiliationQuestions6Formik?.setFieldValue(`ugCat2022`, data?.ug_cat2022);
                    AffiliationQuestions6Formik?.setFieldValue(`pgCat2022`, data?.pg_cat2022);
                    AffiliationQuestions6Formik?.setFieldValue(`ugWorkshops`, data?.ug_workshops);
                    AffiliationQuestions6Formik?.setFieldValue(`pgWorkshops`, data?.pg_workshops);
                    AffiliationQuestions6Formik?.setFieldValue(`ugPublish`, data?.ug_publish);
                    AffiliationQuestions6Formik?.setFieldValue(`pgPublish`, data?.pg_publish);
                    AffiliationQuestions6Formik?.setFieldValue(`ugIntlWorkshop`, data?.ug_intl_workshop);
                    AffiliationQuestions6Formik?.setFieldValue(`pgIntlWorkshop`, data?.pg_intl_workshop);
                    AffiliationQuestions6Formik?.setFieldValue(`ugSports`, data?.ug_sports);
                    AffiliationQuestions6Formik?.setFieldValue(`pgSports`, data?.pg_sports);
                    AffiliationQuestions6Formik?.setFieldValue(`ugNccNss`, data?.ug_ncc_nss);
                    AffiliationQuestions6Formik?.setFieldValue(`pgNccNss`, data?.pg_ncc_nss);
                    AffiliationQuestions6Formik?.setFieldValue(`ugMalpractice`, data?.ug_malpractice);
                    AffiliationQuestions6Formik?.setFieldValue(`pgMalpractice`, data?.pg_malpractice);
                    AffiliationQuestions6Formik?.setFieldValue(`supportingDoc`, data?.supporting_doc);

                })

            }
            else {
                console.log("API DATA NOT FOUND")

            }

        })
    }

    useEffect(() => {
        GetQuestionsubmited6();
        GetCollegeType();


    }, [])

    const fieldConfigurations = [
        { label: '1. Number of Students Admitted ', names: ['ugAddmitted', 'pgAddmitted'] },
        { label: '2. Number of Students detained due to shortage of attendance', names: ['ugAttendance', 'pgAttendance'] },
        { label: '3. Number of Students readmitted / Re-joined', names: ['ugReadmitted', 'pgReadmitted'] },
        { label: '4. Number of Students Got Placements', names: ['ugPlacements', 'pgPlacements'] },
        { label: '5. Number of Students successful in GATE -2023', names: ['ugGate2022', 'pgGate2022'] },
        { label: '6. Number of Students successful in CAT- 2023', names: ['ugCat2022', 'pgCat2022'] },
        { label: '7. Number of Symposia / Conferences / Workshops organized / attended', names: ['ugWorkshops', 'pgWorkshops'] },
        { label: '8. Number of papers published / presented', names: ['ugPublish', 'pgPublish'] },
        { label: '9. Number of participations in National / International Workshops / Conferences:', names: ['ugIntlWorkshop', 'pgIntlWorkshop'] },
        { label: '10. Number of Students being Participated in sports activities', names: ['ugSports', 'pgSports'] },
        { label: '11. Number of Students being Participated in NCC/NSS activities', names: ['ugNccNss', 'pgNccNss'] },
        { label: '12. Number of Malpractice Cases reported', names: ['ugMalpractice', 'pgMalpractice'] }
    ];
    return (
        <>

            {Collegetype && Collegetype === "SqFt" ? (<div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                    padding: '20px',
                    textAlign: 'center',
                }}
            >
                <h2
                    style={{
                        fontSize: '24px',
                        fontWeight: 'bold',
                        textTransform: 'uppercase',
                        letterSpacing: '2px',
                        animation: 'fadeIn 1.5s ease-in-out',
                        color: "red"
                    }}
                >
                    This section is for Engineering colleges only
                </h2>
            </div>) : (<>
                <CommonFormHeading heading={`Consolidated Details of the UG & PG students for AY ${AC_YEAR_OLD}`} />
                <bie.Container fluid className="px-1" >
                    <bie.Container className="outer-page-content-container shadow-none px-6 m-0 mw-100 pb-5">
                        <FormikProvider value={AffiliationQuestions6Formik}>

                            <bie.Row className="px-2 pt-3 mb-3" style={{ border: '0.2px solid #d5d5d5' }}>
                                <Form onChange={AffiliationQuestions6Formik.handleChange} onSubmit={AffiliationQuestions6Formik.handleSubmit} className='affl-form'>
                                    {fieldConfigurations.map((field, index) => (
                                        <bie.Row key={index}>
                                            <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
                                                <label className='field-mandatory '>{field.label}:</label>
                                            </bie.Col>

                                            {field.names.map((name, idx) => (
                                                <React.Fragment key={idx}>
                                                    <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1} className='mb-2'>
                                                        <label className='field-mandatory'>{idx === 0 ? 'UG:' : 'PG:'}</label>
                                                    </bie.Col>
                                                    <bie.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className='mb-2'>
                                                        <Field
                                                            type='text'
                                                            name={name}
                                                            maxLength={8}
                                                            className='form-control'
                                                            onKeyPress={(e) => { allowNumbersOnly(e); }}
                                                            onPaste={(e) => handlePaste(e)}
                                                        />
                                                        <ErrorMessage name={name} component="div" className="text-error" />
                                                    </bie.Col>
                                                </React.Fragment>
                                            ))}
                                        </bie.Row>
                                    ))}
                                    <bie.Row>
                                        <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
                                            <label className='field-mandatory'>13. Any supporting documents ? Please upload pdf :</label>
                                        </bie.Col>

                                        <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mb-2'>
                                            <bie.InputGroup>
                                                <input type="file" className="form-control mb-2" name={`supportingDoc`} accept="application/pdf"
                                                    onChange={(e) => {
                                                        let filename = `supportingDoc`;
                                                        let path = "/Uploads/FFCA_Questionaire6/2023/";
                                                        ImagePdfBucket(e, AffiliationQuestions6Formik, path, `supportingDoc`, filename, "pdf");
                                                    }}
                                                /> &emsp;
                                                {AffiliationQuestions6Formik?.values?.supportingDoc && (<button type='button' className='btn btn-primary' onClick={() => viewImage(AffiliationQuestions6Formik?.values?.supportingDoc)}><FaEye size={20} /></button>)}
                                                <ErrorMessage name="supportingDoc" component="div" className="text-error" />
                                            </bie.InputGroup>
                                        </bie.Col>
                                    </bie.Row>
                                    <div className="pt-1 mb-5">
                                        <button type='submit' className='btn btn-success  float-end mb-2  '>Submit</button>
                                    </div>

                                </Form>
                            </bie.Row>

                        </FormikProvider>
                    </bie.Container>
                </bie.Container >


            </>)}
        </>)
}
